module.exports = __webpack_public_path__ + "img/logo-light.c002654f.png";